<template>
  <section class="login-page">
    <div class="login-page__inner">
      <h1 class="login-page__title">Admin-Login</h1>
      <p class="login-page__intro">
        Bitte melden Sie sich an, um Beratungswünsche und Termin-Slots zu verwalten.
      </p>

      <form class="login-form" @submit.prevent="onSubmit" novalidate>
        <label class="login-form__row">
          <span>E-Mail</span>
          <input
            v-model="email"
            type="email"
            autocomplete="email"
            required
            :disabled="busy"
          />
        </label>

        <label class="login-form__row">
          <span>Passwort</span>
          <input
            v-model="password"
            type="password"
            autocomplete="current-password"
            required
            :disabled="busy"
          />
        </label>

        <p v-if="error" class="login-form__error">{{ error }}</p>

        <button
          class="login-form__submit"
          type="submit"
          :disabled="busy || !email || !password"
        >
          {{ busy ? "Anmelden …" : "Anmelden" }}
        </button>
      </form>
    </div>
  </section>
</template>

<script setup>
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useUserStore } from "@/stores/userStore.js";

const router = useRouter();
const route = useRoute();
const userStore = useUserStore();

const email = ref("");
const password = ref("");
const error = ref("");
const busy = ref(false);

async function onSubmit() {
  error.value = "";
  busy.value = true;
  try {
    const r = await userStore.login(email.value.trim(), password.value);
    if (!r.success) {
      error.value = r.message || "Anmeldung fehlgeschlagen.";
      return;
    }
    if (!userStore.isAdmin) {
      error.value =
        "Login erfolgreich, aber Sie haben keine Admin-Berechtigung.";
      return;
    }
    const next = route.query.redirect || "/admin/termin";
    router.replace(next);
  } catch (_e) {
    error.value = "Anmeldung fehlgeschlagen.";
  } finally {
    busy.value = false;
  }
}
</script>

<style scoped>
.login-page {
  min-height: 60vh;
  padding: 64px 16px;
  background: #f7f9fc;
}
.login-page__inner {
  max-width: 460px;
  margin: 0 auto;
}
.login-page__title {
  margin: 0 0 12px;
}
.login-page__intro {
  margin: 0 0 28px;
  color: #4b5563;
}

.login-form {
  background: #fff;
  border: 1px solid #e3e7ef;
  border-radius: 14px;
  padding: 28px;
  box-shadow: 0 10px 30px rgba(11, 31, 59, 0.06);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-form__row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-weight: 600;
  font-size: 14px;
  color: #111827;
}

.login-form__row input {
  padding: 12px 14px;
  border: 1px solid #d4dae4;
  border-radius: 8px;
  font: inherit;
  background: #f9fafb;
  color: #111827;
}

.login-form__row input:focus {
  outline: none;
  border-color: #2a6bf2;
  background: #fff;
}

.login-form__error {
  margin: 0;
  color: #b91c1c;
  font-size: 14px;
}

.login-form__submit {
  margin-top: 4px;
  background: #2a6bf2;
  color: #fff;
  border: 0;
  padding: 14px 22px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s ease;
}
.login-form__submit:hover:not(:disabled) {
  background: #1d54c8;
}
.login-form__submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
